module.exports = __webpack_public_path__ + "img/cover-dec-techline-left.dca43544.png";